import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { useNonprofitMonthlyActivityLogic } from './hooks/useNonprofitMonthlyActivityLogic';

export const NonprofitMonthlyActivityForm = () => {
  const { t } = useTranslation('eddQuestions');
  const { monthlyTransactionsOptions, monthlyVolumeOptions } = useNonprofitMonthlyActivityLogic();

  return (
    <div className='flex flex-col gap-[16px]'>
      <Text.H9>{t('organic.nonprofitMonthlyActivity.transactionsQuestion')}</Text.H9>
      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTIONS}>
        {({ value, onChange, error }) => (
          <div className='flex flex-col gap-[12px] mt-[8px]'>
            {monthlyTransactionsOptions.map((option) => (
              <CustomRadioButton
                key={option.value}
                onChange={() => onChange(option.value)}
                checked={value === option.value}
                inputId={`transactions-${option.value}`}
                value={option.value}
                name={EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTIONS}
                label={option.label}
              />
            ))}
            <FieldError
              error={error}
              testId={`${EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTIONS}-error`}
            />
          </div>
        )}
      </ControllerWrapper>

      <Text.H9 className='mt-[8px]'>{t('organic.nonprofitMonthlyActivity.valueQuestion')}</Text.H9>
      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTION_VALUE}>
        {({ value, onChange, error }) => (
          <div className='flex flex-col gap-[12px] mb-[12px]'>
            {monthlyVolumeOptions.map((option) => (
              <CustomRadioButton
                key={option.value}
                onChange={() => onChange(option.value)}
                checked={value === option.value}
                inputId={`value-${option.value}`}
                value={option.value}
                name={EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTION_VALUE}
                label={option.label}
              />
            ))}
            <FieldError
              error={error}
              testId={`${EddEmbeddedFields.EDD_NONPROFIT_MONTHLY_TRANSACTION_VALUE}-error`}
            />
          </div>
        )}
      </ControllerWrapper>

      <Text.H9>{t('organic.nonprofitMonthlyActivity.disclaimer')}</Text.H9>
    </div>
  );
};
